(() => {
  if (window.FAMarketingTrackingReady) return;
  window.FAMarketingTrackingReady = true;

  const push = (name, data = {}) => {
    const payload = { event: name, ...data };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('fotoadvent:marketing', { detail: payload }));
  };

  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-fa-event]');
    if (!target) return;
    push(target.dataset.faEvent, {
      fa_label: target.dataset.faLabel || target.textContent.trim().replace(/\s+/g, ' ').slice(0, 120),
      fa_product: target.dataset.faProduct || '',
      fa_url: target.getAttribute('href') || target.dataset.url || ''
    });
  });
})();
